import React, { useEffect, useState } from "react";
import Header from "./Header";
import styled from "styled-components";
import Loader from "./Loader";
import Footer from "./Footer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSolarPanel,
  faBolt,
  faEarthAfrica,
} from "@fortawesome/free-solid-svg-icons";
import PhotovoltaiquesImages from "./PhtovoltaiquesImages";

const Photovoltaïques = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
   const StyledHeading = styled.h6`
    position: relative;
    font-size: 100px;
    color: #008bcd;

    &::before {
      content: "—";
      font-size: inherit;
      color: #008bcd;
      display: block;
    }
  `;
  return (
    <div>
      <div>
        <Header />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        <section
          className="page-title bg-overlay-black-60 parallax"
          data-jarallax='{"speed": 0.6}'
          style={{
            backgroundImage: "url(/assets/images/photovoltaïques/Photovoltaics.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name" style={{ width: "80%" }}>
                  <h1> Transformateurs Photovoltaïques  </h1>
                 
                </div>
                
              </div>
            </div>
          </div>
        </section>

        {/**
         */}
        
        <section className="page-section-ptb  parallax" style={{paddingBottom:"80px"}}>
       
         <PhotovoltaiquesImages/>
        </section>
        <section
          className="page-section-ptb text-center "
          style={{
            padding: "120px 0",
            background: `
      linear-gradient(rgba(0,20,50,0.88), rgba(0,20,50,0.88)),
      url("https://images.unsplash.com/photo-1497440001374-f26997328c1b?q=80&w=1920")
    `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "white",
          }}
        >
          <div className="container">
           <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-left">
              <h2 className="title-effect " style={{color:"#ffff"}}>Nos chiffres</h2>
            </div>
          </div>
        </div>
            <div className="row">
              <div className="col-lg-3 col-sm-6 sm-mb-30">
                <div
                  className="counter big-counter"
                  style={{ color: "#ffb400" }}
                >
                  <span className="timer" data-to={4905} data-speed={10000}>
                    30+
                  </span>
                  <label>Pays</label>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6 sm-mb-30">
                <div
                  className="counter big-counter"
                  style={{ color: "#ffb400" }}
                >
                  <span className="timer" data-to={3750} data-speed={10000}>
                    500+
                  </span>
                  <label>Transformateurs installés</label>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6 xs-mb-30">
                <div
                  className="counter big-counter"
                  style={{ color: "#ffb400" }}
                >
                  <span className="timer" data-to={4782} data-speed={10000}>
                    150MW+
                  </span>
                  <label>Projets photovoltaïques</label>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div
                  className="counter big-counter"
                  style={{ color: "#ffb400" }}
                >
                  <span className="timer" data-to={3237} data-speed={10000}>
                    1966
                  </span>
                  <label>Depuis</label>
                </div>
              </div>
            </div>
          </div>
        </section>
         <section style={{paddingBottom:"80px"}}>
      <div className="container">
        {/*=================================clients */}
            <div className="row mt-70">
              <div className="col-lg-12 col-md-12">
                <h2>Référence photovoltaïque </h2>
                <StyledHeading></StyledHeading>
                {/**<div className="divider double" /> */}
                <br />
                <br />
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="clients-list">
                <div
                  className="owl-carousel"
                  data-nav-dots="false"
                  data-items={5}
                  data-md-items={4}
                  data-sm-items={3}
                  data-xs-items={2}
                  data-xx-items={2}
                >
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/novagreenvolt.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/semap.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/nitrokym.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/MES.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/LOGO-STES.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/eppm.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/Electro-rapide.png"
                      alt=""
                    />
                  </div>

                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/arelec.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/agroliva.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/aurasolpv.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/autoliv.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/awenergie.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/logo-safran.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/scee.png"
                      alt=""
                    />
                  </div>
                  <div className="item">
                    <img
                      className="img-fluid mx-auto"
                      style={{ height: 80 }}
                      src="/assets/images/photovoltaïques/tunicotex.PNG"
                      alt=""
                    />
                  </div>
              
                </div>
              </div>
            </div>
            </div>
      </section>
        <section
          className="page-section-ptb bg-overlay-black-50 parallax"
          data-jarallax='{"speed": 0.6}'
          style={{
            padding: "140px 0",
            background: `
      linear-gradient(rgba(255, 255, 255, 0.5), rgba(0,25,60,0.88)),
      url("https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=1920")
    `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            textAlign: "center",
            color: "white",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center pt-40 pb-40">
                <h2 className="text-white mb-20">
                  Construisons ensemble les réseaux énergétiques de demain
                </h2>
                <p className="text-white">
                  Nos équipes techniques accompagnent vos projets
                  photovoltaïques avec des solutions innovantes, fiables et
                  conformes aux standards internationaux.
                </p>
                <a className="button mt-20" href="/nouscontacter">
                  Nous Contacter
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
     
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Photovoltaïques;
